import { useEffect } from 'react'

import client from 'api/client'
import { useCurrentWorkspace } from './useCurrentWorkspace'
import { useDispatch } from 'react-redux'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { workspacesSet } from 'redux/actions'

export const useFetchWorkspaces = () => {
  const currentWorkspace = useCurrentWorkspace()
  const dispatch = useDispatch()

  useEffect(() => {
    if (currentWorkspace) return

    client.getUserWorkspaces().then((e) => {
      if (e.type === SUCCESS_RESPONSE_TYPE) {
        dispatch(workspacesSet(e.data.workspaces))
      }
    })
  }, [currentWorkspace, dispatch])
}
